import { render, staticRenderFns } from "./AssetsWidget.vue?vue&type=template&id=3eb4d87e&scoped=true"
import script from "./AssetsWidget.vue?vue&type=script&lang=js"
export * from "./AssetsWidget.vue?vue&type=script&lang=js"
import style0 from "./AssetsWidget.vue?vue&type=style&index=0&id=3eb4d87e&prod&lang=scss&scoped=true"
import style1 from "./AssetsWidget.vue?vue&type=style&index=1&id=3eb4d87e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb4d87e",
  null
  
)

export default component.exports